import { debounce } from 'lodash';

class BrixBmi {
  static init(...parameters) {
    return new BrixBmi(...parameters);
  }

  constructor(block) {
    this.block = block;
    this.listItems = block.querySelectorAll('.brix-bmi');
    this.formWrapper = [...block.querySelectorAll('.bmi-wrapper')];
    this.form = block.querySelector('#bmi');
    this.inputField = block.querySelectorAll('#bmi > div');
    this.bmiPin = block.querySelectorAll('.bmi-circle .meter-pin > svg');
    this.button = block.querySelector('#bmi > button');
    this.heightInput = block.querySelector('#height > label > input');
    this.weightInput = block.querySelector('#weight > label > input');

    this.height = parseInt(this.heightInput.value, 10);
    this.weight = parseInt(this.weightInput.value, 10);
    this.buttonLabel = this.button.children[0].innerHTML;

    this.setupListeners();
    this.calculateBmi(this.weight, this.height, false);

    this.updateInputWidth(this.heightInput);
    this.updateInputWidth(this.weightInput);
  }

  calculateBmi(weight, height, showResult = true) {
    const val = (weight / (height / 100 * height / 100)).toFixed(1);
    const showMessage = this.form.dataset.bmi !== '1';

    if (showMessage) {
      [...this.block.querySelectorAll('.bmi-result')].forEach((result) => {
        result.classList.add('-hide');
      });
    }

    if (val <= 18.4) {
      this.bmiPin[0].style.transform = 'rotate(-78deg)';
      if (showResult) {
        if (showMessage) {
          this.block.querySelector('.-level-1').classList.remove('-hide');
        }

        this.button.children[0].innerHTML = val;
      }
    } else if (val > 18.4 && val < 24.9) {
      this.bmiPin[0].style.transform = 'rotate(-46deg)';
      if (showResult) {
        if (showMessage) {
          this.block.querySelector('.-level-2').classList.remove('-hide');
        }

        this.button.children[0].innerHTML = val;
      }
    } else if (val > 24.9 && val < 29.9) {
      this.bmiPin[0].style.transform = 'rotate(-16deg)';
      if (showResult) {
        if (showMessage) {
          this.block.querySelector('.-level-3').classList.remove('-hide');
        }

        this.button.children[0].innerHTML = val;
      }
    } else if (val > 29.9 && val < 34.9) {
      this.bmiPin[0].style.transform = 'rotate(14deg)';
      if (showResult) {
        if (showMessage) {
          this.block.querySelector('.-level-4').classList.remove('-hide');
        }

        this.button.children[0].innerHTML = val;
      }
    } else if (val > 34.9 && val < 39.9) {
      this.bmiPin[0].style.transform = 'rotate(45deg)';
      if (showResult) {
        if (showMessage) {
          this.block.querySelector('.-level-5').classList.remove('-hide');
        }

        this.button.children[0].innerHTML = val;
      }
    } else if (val > 39.9) {
      this.bmiPin[0].style.transform = 'rotate(77deg)';
      if (showResult) {
        if (showMessage) {
          this.block.querySelector('.-level-6').classList.remove('-hide');
        }

        this.button.children[0].innerHTML = val;
      }
    }
  }

  setupListeners() {
    window.addEventListener('resize', debounce(() => {
      this.updateInputWidth(this.heightInput);
      this.updateInputWidth(this.weightInput);
    }, 50));

    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      this.calculateBmi(this.weight, this.height);
    });

    [...this.inputField].forEach((el) => {
      console.log(el);
      const input = el.querySelector('input');
      const incrementButton = el.querySelector('.arrow-up');
      const decrementButton = el.querySelector('.arrow-down');

      input.addEventListener('input', () => {
        this[el.id] = input.value;
        this.updateInputWidth(input);
        this.resetButtonLabel();
      });

      incrementButton.addEventListener('click', () => {
        this.increment(el.id);
        this.updateInputWidth(input);
        this.resetButtonLabel();
      });

      decrementButton.addEventListener('click', () => {
        this.decrement(el.id);
        this.updateInputWidth(input);
        this.resetButtonLabel();
      });
    });
  }

  increment(val) {
    this[val] = parseInt(this[val], 10) + 1;
    if (val === 'height') this.heightInput.value = this[val];
    if (val === 'weight') this.weightInput.value = this[val];
  }

  decrement(val) {
    this[val] = parseInt(this[val], 10) - 1;
    if (val === 'height') this.heightInput.value = this[val];
    if (val === 'weight') this.weightInput.value = this[val];
  }

  resetButtonLabel() {
    this.button.children[0].innerHTML = this.buttonLabel;
  }

  updateInputWidth(input) {
    const inputStyle = input.style;
    const span = document.createElement('span');
    span.innerText = input.value;

    input.parentElement.appendChild(span);

    inputStyle.width = `${span.offsetWidth + 1}px`;
    input.parentElement.removeChild(span);
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-bmi', BrixBmi.init);
}
